import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconListUnorderedComponent } from "./med-icon-list-unordered.component";

@NgModule({
  declarations: [
    MedIconListUnorderedComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconListUnorderedComponent,
  ],
})
export class MedIconListUnorderedModule { }
